import { render, staticRenderFns } from "./hqStuHealthKnowledgeType.vue?vue&type=template&id=4ecac7ac&scoped=true"
import script from "./hqStuHealthKnowledgeType.vue?vue&type=script&lang=js"
export * from "./hqStuHealthKnowledgeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecac7ac",
  null
  
)

export default component.exports